module.exports = __webpack_public_path__ + "static/img/publicity-icon1.1906be5.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-icon1.png
// module id = hVGP
// module chunks = 1